/** biome-ignore-all lint/suspicious/noExplicitAny: temporary */
import { Alert, Button } from '@mantine/core';
import { IconInfoCircle, IconMessages } from '@tabler/icons-react';
import { createFileRoute } from '@tanstack/react-router';

import { useDashboardBookmarks } from '#core/hooks/useDashboardBookmarks.ts';

import classes from './$id.module.css';

export const Route = createFileRoute('/bookmarks/$id')({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  const [bookmarks] = useDashboardBookmarks();
  const bookmark = bookmarks.find((item) => item.title === id);
  if (!bookmark) {
    return null;
  }

  const { title, description } = bookmark;

  return (
    <div className={classes.preview}>
      <header className={classes.previewHeader}>
        <div className={classes.title}>{title as any}</div>
        <Button leftSection={<IconMessages size={16} />} size="xs" variant="subtle">
          Chat with dashboard
        </Button>
      </header>
      <div className={classes.content}>
        <div className={classes.description}>{description}</div>
        <div className={classes.dashboard}>
          <Alert color="blue" icon={<IconInfoCircle />} title="Dashboard Migration Required">
            This bookmark uses a legacy format. Please recreate this dashboard using the new dashboard builder.
          </Alert>
        </div>
      </div>
    </div>
  );
}
